import React from "react";
import { Menu, Divider } from "@mantine/core";

export interface ActionMenuItem {
  type?: "item" | "divider";
  label?: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: () => void;
  color?: string;
  disabled?: boolean;
}

interface ActionMenuProps {
  control: React.ReactElement;
  items: (ActionMenuItem | null | undefined | false)[];
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  position?: "bottom" | "top" | "left" | "right";
  placement?: "center" | "end" | "start";
}

export function ActionMenu({
  control,
  items,
  size = "md",
  position = "bottom",
  placement = "end",
}: ActionMenuProps) {
  return (
    <Menu
      control={control}
      size={size}
      position={position}
      placement={placement}
      styles={{
        item: {
          minHeight: 44,
          padding: "10px 16px",
          fontSize: 15,
          fontWeight: 500,
        },
        itemIcon: {
          width: 20,
          height: 20,
          marginRight: 12,
        },
      }}
    >
      {items.map((item, index) => {
        if (!item) return null;
        if (item.type === "divider") {
          return <Divider key={index} />;
        }
        return (
          <Menu.Item
            key={index}
            icon={item.icon}
            onClick={item.onClick}
            disabled={item.disabled}
            color={item.color}
          >
            {item.label}
          </Menu.Item>
        );
      })}
    </Menu>
  );
}
